import { API } from "aws-amplify";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import Context from "./Context";

const ContextProvider = (props) => {
  const [isAuth, setIsAuth] = useState(false);
  const [userData, setUserData] = useState({});
  const [loader, setLoader] = useState(false);
  const [upcomingClasses, setUpcomingClasses] = useState([]);
  const [previousClasses, setPreviousClasses] = useState([]);
  const [userList, setUserList] = useState([]);
  const [instructorList, setInstructorList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [itemCount, setItemCount] = useState(0);
  const [cartItems, setCartItems] = useState([]);
  const [loadingUpcoming, setLoadingUpcoming] = useState(false);
  const [loadingPrevious, setLoadingPrevious] = useState(false);
  const [loadingInstructors, setLoadingInstructors] = useState(false);
  const [lodingUserList, setLoadingUserList] = useState(false);
  const [cartState, setCartState] = useState({
    subtotal: 0,
    productItems: [],
    quantities: [],
    currencySymbol: "$",
  });

  // Video state management
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Playlist state management
  const [playlists, setPlaylists] = useState([]);
  const [loadingPlaylist, setLoadingPlaylist] = useState(false);
  const [errorPlaylist, setErrorPlaylist] = useState(null);

  // Location state management
  const [location, setLocation] = useState(null);

  // Theme state management (dark/light mode)
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Fetch videos once when user is authenticated

  useEffect(() => {
    API.get("user", "/any/products/Bworkz")
      .then((list) => {
        console.log(list);
        setProductList(list);
      })
      .catch((e) => {
        console.log(e);
        setUserList([]);
      });
  }, []);

  useEffect(() => {
    if (userData.cognitoId) {
      getCartItems(userData.cognitoId);
    }
  }, [userData.cognitoId]);

  const getCartItems = async (cognitoId) => {
    try {
      const response = await API.get(
        "awsaiapp",
        `/any/getcartitems/Bworkz/${cognitoId}`
      );
      setCartItems(response);
      setItemCount(response.length);
      if (Array.isArray(response) && response.length > 0) {
        const quantities = response.map(() => 1);
        const subtotal = response.reduce(
          (total, item, index) =>
            total + (item.amount / 100) * quantities[index],
          0
        );
        const currencySymbol = response[0].currency === "INR" ? "₹" : "$";
        setCartState({
          productItems: response,
          quantities,
          subtotal,
          currencySymbol,
        });
      }
    } catch (error) {
      console.error("Error fetching cart items:", error);
    }
  };

  // useEffect(async() => {
  //   if (isAuth) {
  //     const location = await API.get("user", "/any/get-location");
  //     console.log(location);
  //     setLocation(location.cuntryCode);
  //   }
  // }, [isAuth]);

  const setIsAuthFn = (data) => {
    setIsAuth(data);
  };

  const setUserDataFn = (data) => {
    setUserData(data);
  };

  const setLoaderFn = (data) => {
    setLoader(data);
  };

  const setUpcomingClassesFn = (classes) => {
    setUpcomingClasses(classes);
  };

  const setPreviousClassesFn = (classes) => {
    setPreviousClasses(classes);
  };

  const setUserListFn = (list) => {
    setUserList(list);
  };

  const checkSubscriptionStatus = useMemo(() => {
    if (userData && userData.userType) {
      const subscriptionType = userData.userType;
      const subscriptionStatus = userData.status;
      console.log("Subscription Type:", subscriptionType);
      if (subscriptionType === "admin") {
        return { borderColor: "green" };
      } else if (subscriptionType === "instructor") {
        return { borderColor: "blue" };
      } else if (
        subscriptionType === "member" &&
        subscriptionStatus === "Active"
      ) {
        return { borderColor: "#1b7571" };
      }
    }
    // Return the default style for non-admin and non-active accounts
    return { borderColor: "red" };
  }, [userData]);

  const [imageUrls, setImageUrls] = useState([]);
  const [tempImgSrc, setTempImgSrc] = useState();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const getImagesFromAPI = async (imageUrl) => {
    try {
      const response = await API.get("user", `/any/get-gallery-files/Bworkz`);
      setImageUrls(response.GalleryImagesLinks || []);
      if (imageUrl) {
        const filename = imageUrl.split("/").pop();
        if (response.gallery && response.gallery[filename]) {
          setDescription(response.gallery[filename].description);
          setTitle(response.gallery[filename].title);
        }
      }
    } catch (error) {
      console.error("Error getting images from API: ", error);
    }
  };

  useEffect(() => {
    getImagesFromAPI();
    // eslint-disable-next-line
  }, []);

  const ContextData = {
    isAuth: isAuth,
    setIsAuth: setIsAuthFn,
    userData: userData,
    setUserData: setUserDataFn,
    util: {
      loader: loader,
      setLoader: setLoaderFn,
    },
    upcomingClasses: upcomingClasses,
    setUpcomingClasses: setUpcomingClassesFn,
    previousClasses: previousClasses,
    setPreviousClasses: setPreviousClassesFn,
    userList: userList,
    setUserList: setUserListFn,
    instructorList: instructorList,
    setInstructorList: setInstructorList,
    getCartItems: getCartItems,
    productList: productList,
    setProductList: () => { },
    checkSubscriptionStatus: checkSubscriptionStatus,
    cartItems,
    itemCount,
    cartState,
    setCartState,
    videos,
    setVideos,
    error,
    setError,
    loading,
    setLoading,
    playlists,
    setPlaylists,
    errorPlaylist,
    setErrorPlaylist,
    loadingPlaylist,
    location,
    setLoadingPlaylist,
    // fetchVideos,
    // fetchPlaylists,
    getImagesFromAPI: getImagesFromAPI,
    setTempImgSrc: setTempImgSrc,
    tempImgSrc: tempImgSrc,
    imageUrls: imageUrls,
    setImageUrls: setImageUrls,
    title: title,
    setTitle: setTitle,
    description: description,
    setDescription: setDescription,
    loadingUpcoming,
    setLoadingUpcoming,
    loadingPrevious,
    setLoadingPrevious,
    loadingInstructors,
    setLoadingInstructors,
    lodingUserList,
    setLoadingUserList,
    isDarkMode,
    setIsDarkMode,
  };

  return (
    <Context.Provider value={ContextData}>{props.children}</Context.Provider>
  );
};

export { ContextProvider };
